import * as React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { Link } from 'react-router-dom';
import Router from '../../../../router';
//Utils
import { ColorsContext } from "../../../../Context/ColorsContext"
import { FormatDate } from '../../../../utils/formatDate';

//Hooks
import { useSortByColumn } from '../../../../Hooks/useSortByColumn';

import { Box, Grid, Tooltip } from '@mui/material';
import { LoadingProgress } from '../../../LoadingProgress';
import { getIcon } from '../../../../utils/iconConfig';
import { Delete, Edit } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { TableContainer, TableHeight, CustomTable, TableContent, Cell, CustomTableHead, HeaderCell, CustomIconButtonDemo } from '../../../../pages/styles';


import {
  ContainerButonsEdit,
} from './styles'
import { arrayToString } from '../../../../utils/commonFunctions/convert';

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../../Context/PermissionsContext';


function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const { t } = useTranslation();
  const ability = useAbility(AbilityContext);
  const [headCells, setHeadCells] = React.useState([]);

  React.useEffect(() => {
    returnHeaders();
  }, [])

  const returnHeaders = () => {
    let heads = [
      {
        id: 'status_id',
        center: false,
        disablePadding: false,
        sortArrow: true,
        label: 'workflowManagement.flowState.table.statusCode',
        customSort: 'statusId',
        sticky: true,
        direction: 'left',
      },
      {
        id: 'title',
        center: false,
        disablePadding: true,
        sortArrow: true,
        label: 'workflowManagement.flowState.table.title'
      },
      {
        id: 'icon',
        center: false,
        disablePadding: true,
        sortArrow: true,
        label: 'workflowManagement.flowState.table.icon',
        customSort: 'icon',
      },
      {
        id: 'type',
        center: false,
        disablePadding: true,
        sortArrow: true,
        label: 'workflowManagement.flowState.table.statusType',
        customSort: 'type',
      },
      {
        id: 'role',
        center: false,
        disablePadding: true,
        sortArrow: false,
        label: 'workflowManagement.flowState.table.responsibleRole'
      },
      {
        id: 'executeOption',
        center: false,
        disablePadding: true,
        sortArrow: true,
        label: 'workflowManagement.flowState.table.roleExecute',
        customSort: 'executeOption',
      },
      {
        id: 'lastUpdated',
        center: false,
        disablePadding: true,
        sortArrow: true,
        label: 'workflowManagement.flowState.table.lastUpdate',
        customSort: 'lastUpdate',
      }
    ];

    if (ability.can("UpdateWorkflowStatus") || ability.can("DeleteWorkflowStatus")) {
      heads.push(addActionsRow())
    }

    setHeadCells(heads);
  }

  function addActionsRow() {
    return {
      id: 'actions',
      center: false,
      disablePadding: true,
      sortArrow: false,
      label: 'common.actions.title',
      sticky: true,
      direction: 'right',
    }
  }

  const createSortHandler = (property, customSort) => (event) => {
    onRequestSort(event, property, customSort);
  };

  return (
    <CustomTableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <HeaderCell
            key={headCell.id}
            align={headCell.center ? 'center' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            dataHead={headCell}
          >
            {headCell.sortArrow == true &&
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id, headCell.customSort)}
              >
                {t(headCell.label) || headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span">
                    {order === 'desc' ? '' : ''}
                  </Box>
                ) : null}
              </TableSortLabel>
            }
            {headCell.sortArrow == false &&
              <>
                <Box component="span">
                  {t(headCell.label) || headCell.label}
                </Box>
              </>
            }
          </HeaderCell>
        ))}
      </TableRow>
    </CustomTableHead >
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};




export default function TableWorkflowStatus({
  filteredRequest,
  rows,
  loading,
  handleDelete
}) {

  const { t } = useTranslation();
  const { format } = new FormatDate();
  const { colors } = React.useContext(ColorsContext);
  const ability = useAbility(AbilityContext);

  const { order, orderBy, stableSort, handleRequestSort, getComparator } = useSortByColumn('lastUpdated');

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  function checkUpdatePermissions(row) {
    if (row.isStandard) {
      return ability.can("UpdateWorkflowStatusStandard")
    }
    else {
      return ability.can("UpdateWorkflowStatus")
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;


  return (
    <>
      {loading && <LoadingProgress />}
      {!loading &&
        <TableContainer>
          <TableHeight>
            <CustomTable
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              stickyHeader
              size="small"
            >
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableContent>
                {stableSort(filteredRequest, getComparator())
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                        sx={{ background: row.isStandard ? '#F7F8FA' : '' }}
                      >
                        <Cell 
                          direction='left'
                          sx={{ background: row.isStandard ? '#F7F8FA' : colors.white }}
                        >
                          {row.statusId}
                        </Cell>
                        <Cell data="title">
                          {row.title}
                        </Cell>
                        <Cell data="icon">{getIcon(row) || ''}</Cell>
                        <Cell data="type">{row.typeDescription}</Cell>
                        <Cell data="role">{arrayToString(row.roles, 'name', true)}</Cell>
                        <Cell data="executeOption">{row.executeOption?.name}</Cell>
                        <Cell data="lastUpdated">
                          {format({ date: row?.lastUpdate, format: true })}
                        </Cell>
                        <Cell 
                          direction='right'
                          sx={{ background: row.isStandard ? '#F7F8FA' : colors.white }}
                        >
                          <ContainerButonsEdit>
                            {checkUpdatePermissions(row) &&
                              <Grid item>
                                <Tooltip title={t('workflowManagement.flowState.table.editStatus')}>
                                  <Link to={Router.appWorkflowStatusDetail.replace(':id', row.workflowId || row.idDetail)} state={{ row: row }}>
                                    <CustomIconButtonDemo
                                      size="small"
                                    >
                                      <Edit />
                                    </CustomIconButtonDemo>
                                  </Link>
                                </Tooltip>
                              </Grid>
                            }
                            {ability.can("DeleteWorkflowStatus") &&
                              <Grid item>
                                <Tooltip title={t('workflowManagement.flowState.table.deleteStatus')}>
                                  <CustomIconButtonDemo
                                    size="small"
                                    btnType="delete"
                                    onClick={() => handleDelete(row)}
                                    disabled={row.isStandard ? true : false}
                                  >
                                    <Delete />
                                  </CustomIconButtonDemo>
                                </Tooltip>
                              </Grid>
                            }
                          </ContainerButonsEdit>
                        </Cell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 33 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableContent>
            </CustomTable>
          </TableHeight>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            showFirstButton
            showLastButton
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t('common.itemsPerPage')}
            labelDisplayedRows={
              ({ from, to, count }) => {
                return '' + from + '-' + to + ` ${t('common.of')} ` + count
              }
            }
            sx={{
              borderTop: '1px solid ' + colors.gray,
            }}
          />
        </TableContainer>
      }
    </>
  );
}